import { Directive, ElementRef, Input, OnInit, NgModule, OnChanges } from '@angular/core';
declare let $: any;

@Directive({ selector: '[aDisabled]' })
export class aDisabled implements OnInit, OnChanges {

    @Input()
    aDisabled: boolean;

    private aTag: any;

    constructor(element: ElementRef) {
        this.aTag = $(element.nativeElement);
    }

    private enabled() {
        if (!this.aDisabled) {
            this.aTag.removeClass("disabled");
            this.aTag.parent().removeClass("not-allowed");
        }
    }

    private disabled() {
        if (this.aDisabled) {
            this.aTag.addClass("disabled");
            this.aTag.parent().addClass("not-allowed");
        }
    }

    ngOnInit() {
        this.enabled();
        this.disabled();
    }

    ngOnChanges(valueOnChange: any) {
        if (valueOnChange.aDisabled != null) {
            this.enabled();
            this.disabled();
        }
    }
}

@NgModule({
    declarations: [aDisabled],
    imports: [],
    exports: [aDisabled]
})
export class aDisabledModule {


}

